export default {
  left_column: {
    title: 'Vérifier le solde',
    description:
      'Entrez le code de votre carte cadeau pour vérifier le solde restant. Le code figure sur le PDF de votre carte cadeau.',
  },
  title: 'Vérifier le solde de la carte cadeau',
  subtitle: 'Saisissez un code de carte cadeau pour vérifier son solde actuel',
  error: {
    title: 'Carte cadeau introuvable !',
    description: 'Veuillez saisir un code de carte cadeau valide.',
  },
  gift_card: {
    title: 'Carte cadeau trouvée !',
    balance: 'Solde',
    value: 'Valeur',
    expires_at: 'Expire le',
  },
  form: {
    code: {
      label: 'Code de la carte cadeau',
    },
  },
  buttons: {
    check_balance: 'Vérifier le solde',
  },
};
